/**
 * Token Storage Utility
 * Handles secure storage and retrieval of authentication tokens
 */

const ACCESS_TOKEN_KEY = 'smartplan_access_token';
const REFRESH_TOKEN_KEY = 'smartplan_refresh_token';

export const tokenStorage = {
  /**
   * Get the stored access token
   * @returns {string|null} The access token or null if not found
   */
  getAccessToken() {
    try {
      return localStorage.getItem(ACCESS_TOKEN_KEY);
    } catch (error) {
      console.error('Error getting access token:', error);
      return null;
    }
  },

  /**
   * Get the stored refresh token
   * @returns {string|null} The refresh token or null if not found
   */
  getRefreshToken() {
    try {
      return localStorage.getItem(REFRESH_TOKEN_KEY);
    } catch (error) {
      console.error('Error getting refresh token:', error);
      return null;
    }
  },

  /**
   * Store both access and refresh tokens
   * @param {string} accessToken - The access token
   * @param {string} refreshToken - The refresh token
   */
  setTokens(accessToken, refreshToken) {
    try {
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    } catch (error) {
      console.error('Error setting tokens:', error);
      throw error;
    }
  },

  /**
   * Clear all stored tokens
   */
  clearTokens() {
    try {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    } catch (error) {
      console.error('Error clearing tokens:', error);
    }
  },

  /**
   * Check if tokens exist
   * @returns {boolean} True if both tokens exist
   */
  hasTokens() {
    return !!tokenStorage.getAccessToken() && !!tokenStorage.getRefreshToken();
  },
};
